'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { forwardRef, useMemo, } from 'react';
import styles from './clamp-text.module.css';
export const ClampText = forwardRef(({ as: Component = 'span', className, children, rows = 1, style, inline, ...otherProps }, forwardedRef) => {
    const dynamicStyle = useMemo(() => ({
        '--r': rows,
    }), [rows]);
    return (_jsx(Component, { ref: forwardedRef, style: { ...dynamicStyle, ...style }, className: clsx(styles.ClampText, className), "data-clamp-text-inline": inline, ...otherProps, children: children }));
});
